// import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
// import { provideRouter,Routes, withDebugTracing } from '@angular/router';
// import { routes } from './app.routes';
// import { AuthService } from './services/auth.service';

// export const appConfig: ApplicationConfig = {
//   providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes)]
// };


// export function initializeApp(authservice: AuthService) {
//     return ()=>authservice.initAuth();
// }

// providers: [
//   AuthService,
//   {
//     provide: APP_INITIALIZER,
//     useFactory: initializeApp,
//     deps: [AuthService],
//     multi: true
//   }   
// ]

import { 
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection
} from '@angular/core';

import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { AuthService } from './services/auth.service';
import { authInterceptor } from './interceptors/auth.interceptor';

/* APP INITIALIZER */
export function initializeApp(authService: AuthService) {
  return () => authService.initAuth();
}

export const appConfig: ApplicationConfig = {
  providers: [

    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(routes),

    /* HTTP + INTERCEPTOR */
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),

    /* AUTH SERVICE */
    AuthService,

    /* APP INITIALIZER */
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AuthService],
      multi: true
    }
  ]
};
